$('.banner-slides').slick({
    dots: true,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Next</button>',
    nextArrow: '<button type="button" class="slick-next">Pre</button>',
    responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },{
            breakpoint: 1259,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }, 
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

  

$('.promo-peoducts-slider').slick({
    dots: true,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Next</button>',
    nextArrow: '<button type="button" class="slick-next">Pre</button>',
    responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },{
            breakpoint: 1259,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }, 
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});


$('.single_product_slider').slick({
    dots: false,
    infinite: true,
    vertical: true, 
    verticalSwiping: true,
    speed: 600,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Next</button>',
    nextArrow: '<button type="button" class="slick-next">Pre</button>',
    responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },{
            breakpoint: 1259,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, 
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
 
$('.single_product_slider').on('wheel', function(e) {
    e.preventDefault();  // Prevent the default scroll behavior
  
    if (e.originalEvent.deltaY < 0) {
      $(this).slick('slickPrev'); // Scroll up (previous slide)
    } else {
      $(this).slick('slickNext'); // Scroll down (next slide)
    }
  });